import { useLayoutEffect, useState } from 'react';
/**
 * React Hook which contains reusable logic used to get the inner width and height of a window
 */
export const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState([window.innerWidth, window.innerHeight]);
    useLayoutEffect(() => {
        const updateSize = () => {
            setWindowSize([window.innerWidth, window.innerHeight]);
        };
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);
    return windowSize;
};
//# sourceMappingURL=useWindowSize.js.map